import React from 'react';
import PropTypes from 'prop-types';

export default class DataWidgetDataBar extends React.PureComponent {

    render() {

        var barClassName = "data-bar-for-percentage";
        switch (this.props.type) {
            case "usage-total":
                barClassName += " usage-total";
                break;
            case "plan-total":
                barClassName += " plan-total";
                break;
            case "top-up":
                barClassName += " top-up";
                break;
            default:
                console.error("DataWidgetDataBar unsupported type");
                return null;
        }
        return (
            <div className={barClassName} style={{ 'width': this.props.percentageWidth + '%'}}></div>
        )
    }
}

DataWidgetDataBar.propTypes = {
    type: PropTypes.string.isRequired, // 'usage-total', 'plan-total', 'top-up', 'top-up last'
    percentageWidth: PropTypes.number.isRequired,
};
